import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M2 2a26.6 26.6 0 0 1 10 20c.9-6.82 1.5-9.5 4-14",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M16 8c4 0 6-2 6-6-4 0-6 2-6 6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M17.41 3.6a10 10 0 1 0 3 3", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Vegan";
const Vegan = memo(themed(Icon));
export {
  Vegan
};
//# sourceMappingURL=vegan.js.map
